import { ChatService } from './../../../services/chat.service';
import { BasketService } from '../../../services/basket.service';
import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';
import { NotificationService } from '../../../services/notification.service';

@Component({
    selector: 'app-signout',
    templateUrl: './signout.component.html',
    styleUrls: ['./signout.component.scss']
})
export class SignoutComponent implements OnInit {

    constructor(
        private authService: AuthService,
        private router: Router,
        private notificationService: NotificationService,
        private basketService: BasketService,
        private chatService: ChatService,
    ) { }

    ngOnInit(): void {
    }

    signOut() {
        this.chatService.sendOfflineSignal();
        this.notificationService.stopListening();
        this.basketService.removeVoucher();
        this.authService.logout().subscribe(() => {
            this.authService.clearAuthTimeout();
            
            // We now purge basket when user signs out
            // this.basketService.calculateBasketTotal();
            this.basketService.renewBasket();

            this.router.navigate(['/']);
        });
      

    }
}
